export const CurrentRouteInfoSymbol = Symbol('CurrentRouteInfo')
export const SamePageUrlChangeListenerSymbol = Symbol('SamePageUrlChangeListener')
